var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 15.8333H3.16667C2.29222 15.8333 1.58333 15.1245 1.58333 14.25V3.95833H0V2.375H3.16667V1.58333C3.16667 0.708883 3.87555 0 4.75 0H9.5C10.3745 0 11.0833 0.708883 11.0833 1.58333V2.375H14.25V3.95833H12.6667V14.25C12.6667 15.1245 11.9578 15.8333 11.0833 15.8333ZM3.16667 3.95833V14.25H11.0833V3.95833H3.16667ZM4.75 1.58333V2.375H9.5V1.58333H4.75ZM9.5 12.6667H7.91667V5.54167H9.5V12.6667ZM6.33333 12.6667H4.75V5.54167H6.33333V12.6667Z",
    fill: "#0C82DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFull);
export default __webpack_public_path__ + "static/media/trash_full.7f9e1d6248b2577a17f1fb7e66e949b5.svg";
export { ForwardRef as ReactComponent };